import { createContext } from 'react';
import { usePattern } from '../hooks/usePattern';

export const PatternContext = createContext();

export const PatternInputProvider = (props) => {
	const { getPattern, getSamplePattern, ...rest } = usePattern();

	return (
		<PatternContext.Provider
			value={{
				...rest,
				// Preserve PascalCase names consumed by PrintPattern and Purchase
				GetPattern: getPattern,
				GetSamplePattern: getSamplePattern,
			}}
		>
			{props.children}
		</PatternContext.Provider>
	);
};
